<script setup lang="ts">
import merge from 'lodash-es/merge';
import type { ListItemOptionsModel } from '#layers/prawopl/app/pages/cms/modules/wk-labels/_runtime/services/LabelsService';
import ArticleLabelsService from '#layers/prawopl/app/pages/cms/modules/wk-labels/_runtime/services/LabelsService';

defineOptions({
    name: 'WkArticlesLatestSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue',): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    quantity: 0,
    labelId: null,
    showPictures: false,
    showAuthors: false,
    showLead: false,
    showPublicationDate: false
});
const labels = ref<ListItemOptionsModel[]>([]);

const form = computed<any>(() =>
{
    return props.modelValue;
});

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            labelId: schema.string().nullable().required($t('[[[Wybranie etykiety rodzajowej jest wymagane]]]')),
            quantity: schema.number().min(0, $t('[[[Minimalna liczba artykułów to 0]]]'))
        })
    }));
}

async function loadLabels(): Promise<boolean>
{
    try
    {
        const response = await ArticleLabelsService.getOptions();

        labels.value = [{
            id: null,
            name: $t('[[[Brak etykiety]]]')
        }].concat(response);
    }
    catch (ex)
    {
        return false;
    }

    return true;
}
onBeforeMount((): void =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
    loadLabels();
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Liczba artykułów]]]')" :invalid-feedback="form.$errors.first('settings.quantity')" :state="form.$errors.state('settings.quantity')">
        <IdeoFormNumber v-model="form.settings.quantity" :min="0" />
    </IdeoFormGroup>

    <IdeoFormGroup :label="$t('[[[Etykieta rodzajowa]]]')" :invalid-feedback="form.$errors.first('labelId')" :state="form.$errors.state('settings.labelId')" required>
        <IdeoFormSelect v-model="form.settings.labelId" name="labelId" :options="labels" value-field="id" text-field="name" />
    </IdeoFormGroup>

    <IdeoFormGroup>
        <IdeoFormCheckbox v-model="form.settings.showPictures">
            {{ $t('[[[Pokaż zdjęcia]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>

    <IdeoFormGroup>
        <IdeoFormCheckbox v-model="form.settings.showAuthors">
            {{ $t('[[[Pokaż autorów]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>

    <IdeoFormGroup>
        <IdeoFormCheckbox v-model="form.settings.showLead">
            {{ $t('[[[Pokaż wprowadzenie]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>

    <IdeoFormGroup>
        <IdeoFormCheckbox v-model="form.settings.showPublicationDate">
            {{ $t('[[[Pokaż datę publikacji]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>
</template>
